import type { FC } from 'react';
import { useGetControlGroupById } from 'src/hooks/queries';

type Props = {
  controlGroupId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ controlGroupId }) => {
  const { data } = useGetControlGroupById(controlGroupId!, !controlGroupId);

  return <>{data?.control_group?.[0]?.Title}</>;
};

export default Breadcrumb;
